module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step2b_Image13c.9e414868.jpg";